import { Component, createRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH } from '@fortawesome/pro-solid-svg-icons/faEllipsisH';

import { Popover, Overlay } from 'react-bootstrap';
import { checkOneTopicCheck } from '../../../helpers/watchlistHelperFunctions';
import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

export class WatchlistTopicsToolip extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      popoverOpen: false,
    };
    this.dots = createRef();
  }

  handleCheckWlTopic(e, token, asset) {
    const {
      actions, piwikEnabled, topicName, activeWatchlistTopics,
    } = this.props;

    e.stopPropagation();

    if (piwikEnabled && !asset.hidden) {
      _paq.push(['trackEvent', 'WL page', 'Unselect this topic', topicName]);
    } else if (piwikEnabled && asset.hidden) {
      _paq.push(['trackEvent', 'WL page', 'Select this topic', topicName]);
    }

    this.setState({ popoverOpen: false });

    if (!token) return actions.uncheckGuestQuery(asset.id, !asset.hidden);

    return actions.uncheckTopic(asset.query, asset.id, !asset.hidden, token, activeWatchlistTopics);
  }

  handleTopicDelete(e, token, assetId, watchlistId, asset) {
    const { actions, piwikEnabled, topicName } = this.props;

    e.stopPropagation();

    if (piwikEnabled) _paq.push(['trackEvent', 'WL page', 'Delete topic from WL', topicName]);

    this.setState({ popoverOpen: false });
    if (token) {
      if (asset.query) return actions.deleteQuery(assetId, watchlistId, token);
      return actions.deleteAsset(assetId, watchlistId, token);
    }
    return actions.removeGuestQuery(assetId);
  }

  handleCheckAllUncheckedTopics(e, activeWatchlistTopics, token) {
    const { actions } = this.props;

    e.stopPropagation();

    this.setState({ popoverOpen: false });
    actions.checkAllUncheckedTopics(activeWatchlistTopics, token);
  }

  handleSelectOneTopic(e, asset, topicId, activeWatchlistTopics, token) {
    const { actions, piwikEnabled, topicName } = this.props;

    e.stopPropagation();

    if (piwikEnabled) _paq.push(['trackEvent', 'WL page', 'Select ONLY this topic', topicName]);

    this.setState({ popoverOpen: false });
    actions.selectOneAsset(
      topicId, activeWatchlistTopics, token, asset.id, activeWatchlistTopics,
    );
  }

  toggle() {
    const { popoverOpen } = this.state;
    this.setState({
      popoverOpen: !popoverOpen,
    });
  }

  render() {
    const {
      topicId,
      asset,
      watchlistId,
      token,
      activeWatchlistTopics,
    } = this.props;
    const { popoverOpen } = this.state;

    return (
      <>
        <div
          id={`Popover${topicId}`}
          ref={this.dots}
          onClick={this.toggle}
        >
          <FontAwesomeIcon icon={faEllipsisH} />
        </div>
        <Overlay
          placement="bottom-end"
          transition={false}
          show={popoverOpen}
          target={this.dots.current}
          onHide={this.toggle}
          rootClose
          rootCloseEvent="click"
        >
          <Popover className={Styles.popover}>
            <ul className="m-0" onClick={this.closePopover}>
              <li onClick={(e) => this.handleTopicDelete(e, token, asset.id, watchlistId, asset)}>
                <i className={Styles.delete} />
                <span>
                  Delete topic from watchlist
                </span>
              </li>
              <li onClick={(e) => this.handleCheckWlTopic(e, token, asset, watchlistId)}>
                {!asset.hidden ? (
                  <>
                    <i className={Styles.unselect} />
                    <span>
                      Unselect this topic
                    </span>
                  </>
                ) : (
                  <>
                    <i className={Styles.select} />
                    <span>
                      Select this topic
                    </span>
                  </>
                )}
              </li>
              {checkOneTopicCheck(activeWatchlistTopics) && !asset.hidden
                ? (
                  <li
                    onClick={(e) => {
                      this.handleCheckAllUncheckedTopics(e, activeWatchlistTopics, token);
                    }}
                  >
                    <i className={Styles.select_all} />
                    <span>Select all topics</span>
                  </li>
                ) : (
                  <li
                    onClick={(e) => {
                      this.handleSelectOneTopic(e, asset, topicId, activeWatchlistTopics, token);
                    }}
                  >
                    <i className={Styles.isolate} />
                    <span>Select ONLY this topic</span>
                  </li>
                )}
            </ul>
          </Popover>
        </Overlay>
      </>
    );
  }
}

export default withComponentName(WatchlistTopicsToolip);
